import { useTranslation } from 'react-i18next'

import Text from '../../Text'

import * as styles from './SettingsFieldGroup.module.css'

function SettingsFieldGroup({
  children,
  className = styles.SettingsFieldGroup,
  titleKey,
}) {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <Text Element='h4' className={styles.title}>
        {t(titleKey)}
      </Text>
      {children}
    </div>
  )
}

export default SettingsFieldGroup
